import React from 'react';
import { PageLayout } from 'containers/layout';
import ChangePasswordForm from 'containers/auth/ChangePasswordForm';

function ChangePassword() {
  return (
    <PageLayout title="Change Password" back="/account-settings">
      <ChangePasswordForm />
    </PageLayout>
  );
}

export default ChangePassword;
